<template>
	<div :class="classNames" v-if="artwork" @click="reviewArtwork">

		<div class="artwork-item-image-wrapper">
			<img v-if="thumbnail" decoding="async" class="artwork-item-image" :src="thumbnail"
				:srcset="thumbnail_srcset" :alt="artwork.title">

			<div class="artwork-item-id">{{ artwork.id }}</div>

			<div v-if="showReviews" class="artwork-item-icons">
				<!-- reviewed-->
				<span v-if="!artwork.reviewed_me" @click="reviewArtwork" class="artwork-item-icon fal fa-comment"
					title="Not yet reviewed"></span>
				<span v-else class="artwork-item-icon fas fa-comment-check"
					title="Reviewed"></span>

				<!-- short listed -->
				<span v-if="!artwork.shortlist_me" @click="reviewArtwork" class="artwork-item-icon fal fa-heart"
					title="Not short listed"></span>
				<span v-else class="artwork-item-icon fas fa-heart"
					title="Short listed"></span>

				<!-- finalist -->
				<span v-if="!artwork.finalist_me" class="artwork-item-icon fal fa-trophy"
					title="Nominate as finalist"></span>
				<span v-else class="artwork-item-icon fas fa-trophy" title="Nominated as finalist"></span>

			</div>

			<div v-else class="artwork-item-icons">
				<span v-if="artwork.category" class="badge text-bg-secondary">{{ artwork.category.name }}</span>
				<span v-if="competitionStatus" class="badge text-bg-light">{{ competitionStatus }}</span>
			</div>


		</div>

		<!-- text meta -->
		<div>
			<div v-if="showReviews" class="artwork-item-badges">
				<span class="badge text-bg-dark">
					<span class="artwork-item-icon fal fa-comment me-1"></span>
					{{ numReviews }}
				</span>
				<span class="badge text-bg-primary">
					<span class="artwork-item-icon fal fa-heart me-1"></span>
					{{ numShortlists }}
				</span>
				<span class="badge text-bg-light">
					<span class="artwork-item-icon fal fa-trophy me-1"></span>
					{{ numNominations }}
				</span>
			</div>

			<div class="artwork-item-artist">
				{{ artwork.artist }} | {{ artwork.date }}
			</div>

			<h4 class="artwork-item-title">
				{{ artworkTitle }}
			</h4>

			<div v-if="showReviews" class="artwork-item-meta">
				<div class="artwork-item-review">
					<template v-if="numReviews">
						<div class="artwork-item-review-row">
							<label>Reviews:</label>
							<span>{{ initialsWhere({'reviewed' : 'Yes'}) }}</span>
						</div>
						<div v-if="numShortlists" class="artwork-item-review-row">
							<label>Shortlist:</label>
							<span>{{ initialsWhere({'shortlist' : 'Yes'}) }}</span>
						</div>
						<div v-if="numNominations" class="artwork-item-review-row">
							<label>Finalist:</label>
							<span>{{ initialsWhere({'finalist' : 'Yes'}) }}</span>
						</div>
					</template>
					<template v-else>
						<p>No reviews yet</p>
					</template>
				</div>
			</div>

			<div v-else>
				<p>{{ artwork.statement }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {

	props: {
		artwork: {
			type: Object,
			required: true
		},
		showReviews: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		artworkTitle() {
			return this.artwork.title.replaceAll('&quot;', '"');
		},
		classNames() {
			return {
				'artwork-item': true,
				'has-thumbnail': this.thumbnail,
			}
		},

		thumbnail() {
			return this.artwork.thumbnail;
		},

		thumbnail_srcset() {
			return this.artwork.thumbnail_srcset;
		},

		review() {
			// find my review in the array
			return this.$store.getters.getMyReview(this.artwork);
		},

		// return judge's names from all reviews
		reviewNames() {
			// filter only items which are reviewed
			let names = this.artwork.reviews.filter(review => review.reviewed == 'Yes').map(review => review.author_name);
			return names;
		},

		numReviews() {
			return this.findReviews({ reviewed: 'Yes' }).length;
		},

		numNominations() {
			return this.findReviews({ finalist: 'Yes' }).length;
		},

		numShortlists() {
			return this.findReviews({ shortlist: 'Yes' }).length;
		},

		competitionStatus() {

			if( this.artwork.winner ) {
				return 'Winner';
			} else if( this.artwork.finalist ) {
				return 'Finalist';
			}

			return null;
		}
	},

	methods: {	
		reviewArtwork() {
			var route = this.showReviews ? 'review' : 'view';
			this.$router.push({ name: route, params: { artworkId: this.artwork.id } });
		},

		initialsWhere(conditions) {
			let reviews = this.findReviews(conditions);
			let names = reviews.map(review => review.author_name);
			return names.map(name => name.split(' ').map(word => word[0]).join('')).join(', ');
		},

		findReviews(conditions) {
			return this.artwork.reviews.filter(review => {
				for (let key in conditions) {
					if (review[key] != conditions[key]) {
						return false;
					}
				}
				return true;
			});
		}
	}
}
</script>